// extracted by mini-css-extract-plugin
module.exports = {"weekSoldCount":"weeklySold_weekSoldCount__8HOWt"};